import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OutboundSOAddProductDirectRBAC = {
  pageID: '2109e94fe222eec8aefa00e8907157fe',
  elementID: {
    ButtonSubmit: '985936dd1a91e1ac4ef56cd738156c66',
  },
} as const

export const useRBACOutboundSOAddProductDirectPage = createUseRBAC(
  OutboundSOAddProductDirectRBAC.elementID,
)
export type UseRBACOutboundSOAddProductDirectPageType = ReturnType<
  typeof useRBACOutboundSOAddProductDirectPage
>
